module.exports = __webpack_public_path__ + "static/media/adapa.26ce2d1a.png";